import React from "react";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";

const EmailRightBar = [];

function Email() {
  return (
    <>
      <div>
        <PageHeading heading="Email" />
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={EmailRightBar} />
      </div>
    </>
  );
}

export default Email;
